import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';

const CalenderConsentFailure = () => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(135deg, #e3f2fd, #90caf9)',
      }}
    >
      <Card
        title="Google Calendar Connection Failed"
        subTitle="We couldn't link your calendar"
        style={{
          width: '800px',
          textAlign: 'center',
          borderRadius: '16px',
          boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
          background: '#fff',
        }}
      >
        <i
          className="pi pi-times-circle"
          style={{ fontSize: '4rem', color: '#d32f2f', marginBottom: '1rem' }}
        ></i>

        <p style={{ color: '#555', marginBottom: '1rem' }}>
          Something went wrong while connecting to Google Calendar. Please try
          again.
        </p>

        <Divider />
      </Card>
    </div>
  );
};

export default CalenderConsentFailure;
